const queryOrgDetails = `
query GetOrganizzazione($id: ID!) {
  organizzazione(id: $id) {
    objectId
    nome
    stato
    tipo_istanza
    plan
    subscription_started_at
    recurring_billing_frequency
    email
    telefono1
    telefono2
    cellulare1
    cellulare2
    indirizzo
    cap
    provincia
    citta
    nazione
    partita_iva
    sito
    pec
    giotto
    ofc
    tipo_licenza
    zoho_plan_code
    venditore
    data_scadenza
    data_scadenza_giotto
    stripe_created_at
    createdAt
    updatedAt
    percent_services_used
    limite_servizi
    total_services_current_billing_period
    spazio
    spazio_occupato
    spazio_disponibile
    spazio_allegati
    stripe_customer_id
    fatturazione_attiva
    fatturazione_passiva
    fattura_adhoc
    preventivo_adhoc
    ordine_adhoc
    demo_ofc_already_done
    marketplace
    utilizzatore_prestazioni
    fornitore_centro_prenotazioni
    integrazione_annunci_funebri
    zoho_last_billing
    zoho_next_billing
    zoho_created_at
    jira_id
    logo {
      url
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default queryOrgDetails; 
